
import React, { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { format, parse } from 'date-fns';

interface TimeFieldProps {
  id?: string;
  value?: Date;
  onChange?: (date: Date) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export const TimeField: React.FC<TimeFieldProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  placeholder = 'Select time',
  className,
}) => {
  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      // Convert the time string to a Date object
      const [hours, minutes] = e.target.value.split(':');
      const newDate = new Date();
      newDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
      onChange?.(newDate);
    }
  };

  // Format the time value for the input
  const timeString = value ? format(value, 'HH:mm') : '';

  return (
    <Input
      id={id}
      type="time"
      value={timeString}
      onChange={handleTimeChange}
      disabled={disabled}
      className={cn("", className)}
    />
  );
};
